import { IAPIGetMembershipForEditResponse } from "../interfaces";
import { PricingPageService } from "../services";
import { RelatedSectionModel } from "./DonationAndItemModel";
import { ItemDetailPageModel } from "./ItemDetailPageModels"; 
import { PricingPageInputModel } from "./PriceInputs.model";

 
export class ItemMembershipModel {
    detailSection: ItemDetailPageModel;
    pricingInputs: PricingPageInputModel | null = null;
    relatedSectionData?: RelatedSectionModel;
    //prices is being used only in purchase links for now.
    prices?: PricingPageInputModel[];
    constructor(data?: Partial<ItemMembershipModel>) {
        this.detailSection = (data && data.detailSection) || new ItemDetailPageModel();
        this.pricingInputs = data?.pricingInputs || null;
        this.relatedSectionData = data?.relatedSectionData && new RelatedSectionModel(data?.relatedSectionData);
        this.prices = (data?.prices || []).map((price) => new PricingPageInputModel(price));
    }

    static deserializeAPIModel(data: IAPIGetMembershipForEditResponse): ItemMembershipModel {
        const defaultPrice = data.prices?.find((price) => price.id === data.defaultPriceId);
        const mappedData: Partial<ItemMembershipModel> = {
            detailSection: ItemDetailPageModel.deserializeAPIModel(data),
            pricingInputs: defaultPrice ? PricingPageInputModel.deserializeAPIModel(defaultPrice) : null,
            relatedSectionData:
                data.options?.relatedItems && RelatedSectionModel.deserializeAPIModel(data.options?.relatedItems),
            prices: PricingPageService.deserializeAPIModel(data.prices || []),
        };
        return new ItemMembershipModel(mappedData);
    }
}
